<template>
  <b-container fluid class="bg-white">
    <div class="row">
      <div class="col-lg-1"></div>
      <div class="col-lg-10">
        <div v-if="loading" class="lz-summary-loading">
          <b-spinner small></b-spinner>
          Loading your allowance...
        </div>
        <div v-else-if="summaryCards.length" class="lz-summary-grid">
          <div
            v-for="(card, index) in summaryCards"
            :key="`${card.key}-${index}`"
            class="lz-stat-card">
            <div class="lz-stat-card-title">{{ card.title }}</div>
            <div class="lz-stat-card-figure">
              <span class="lz-stat-card-value">{{ card.headlineValue }}</span>
              <span class="lz-stat-card-unit" v-if="card.headlineLabel">{{
                card.headlineLabel
              }}</span>
            </div>
            <ul class="lz-stat-card-rows" v-if="card.rows.length">
              <li v-for="row in card.rows" :key="row.label">
                <span>{{ row.label }}</span><strong>{{ row.value }}</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-1"></div>
    </div>
  </b-container>
</template>

<script>
import ServicesOld from '../../../services/index.vue'
import Services from '../../../services/main.service.vue'

// Same list as admin/holiday-components/Stats.vue: these types are not capped
// by an allowance, so their figure is always 0.
const TypesWithoutAllowance = ['UNPAID', 'PATERNITY', 'WFH']

export default {
  name: 'HolidayStats',
  props: {
    selectedYear: {
      type: Number,
      required: true
    },
    mobileView: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    // One card per leave type. Value resolution mirrors what the old summary
    // table's cell templates did; the difference is that fields which only
    // apply to some types (carry-forward, in-lieu, balance) are simply
    // omitted from a card rather than left as blank columns.
    summaryCards() {
      return this.statItems.map((itm) => {
        const allowance = itm.groups?.[itm.key] || itm.allowance || ''
        const hasBalance = ![null, undefined, ''].includes(itm.balance)
        const rows = []
        let headlineValue = '—'
        let headlineLabel = ''

        if (hasBalance) {
          headlineValue = itm.balance < 0 ? 0 : itm.balance
          headlineLabel = 'days left'
        } else if (allowance !== '') {
          headlineValue = allowance
          headlineLabel = 'days allowance'
        }

        // Allowance is on every card that has one, zero included, so the
        // figure the balance is measured against is always visible. Unpaid,
        // maternity/paternity and WFH have no allowance at all, so they are
        // left out rather than implying a budget of nought.
        if (!TypesWithoutAllowance.includes(itm.key)) {
          rows.push({ label: 'Allowance', value: allowance === '' ? 0 : allowance })
        }

        // Only annual leave has these two, and only when they are actually
        // topped up: a zero adds nothing the allowance does not already say.
        if (itm.key === 'ANNUAL') {
          const carryForward = Number(itm.groups?.CARRYFORWARD) || 0
          const inLieu = Number(itm.groups?.INLIEU) || 0
          if (carryForward > 0) {
            rows.push({ label: 'Carry-forward', value: carryForward })
          }
          if (inLieu > 0) {
            rows.push({ label: 'In-lieu', value: inLieu })
          }
        }
        // Nothing pending, taken or turned down is the normal state, so zeros
        // on these three are noise.
        if (Number(itm.pending) > 0) {
          rows.push({ label: 'Pending', value: itm.pending })
        }
        if (Number(itm.approved) > 0) {
          rows.push({ label: 'Approved', value: itm.approved })
        }
        if (Number(itm.rejected) > 0) {
          rows.push({ label: 'Rejected', value: itm.rejected })
        }

        return {
          key: itm.key,
          title: String(itm.value || '').toUpperCase(),
          headlineValue,
          headlineLabel,
          rows
        }
      })
    }
  },
  data: () => {
    return {
      loading: false,
      statItems: []
    }
  },
  mounted() {
    this.$root.$on('parent_tab_holidays_selected', this.tabMounted)
    this.$root.$on('saved', this.tabMounted)
  },
  methods: {
    async tabMounted() {
      this.loading = true
      await this.getStats()
      this.loading = false
    },
    async getStats() {
      const TypesToHide = ['ANNUALSALE']
      const { status, data } = await ServicesOld.GetHolidayAllowences({
        year: this.selectedYear
      })
      if (status == 200) {
        this.statItems = data.content
          .map((itm) => {
            itm.balance = ''
            if (itm.value.toLowerCase() == 'personal') {
              itm.value = 'Personal/Sick'
              itm.groups[itm.key] = ''
              // itm.balance = itm.remains
            }
            if (
              ['annual holiday', 'personal/sick', 'birthday'].includes(
                itm.value.toLowerCase()
              )
            ) {
              itm.balance = itm.remains
            }
            itm.pending = itm.pending || ''
            itm.approved = itm.approved || ''
            itm.rejected = itm.rejected || ''
            return itm
          })
          .filter((itm) => {
            return !TypesToHide.includes(itm.key)
          })
      }
    }
  },
  watch: {
    selectedYear: {
      handler: 'tabMounted',
      immediate: true
    }
  }
}
</script>
